(function(){
  var root = document.querySelector('[data-hh-pdp]'); if (!root) return;
  var variants = []; try { variants = JSON.parse(root.querySelector('[data-hh-variants]').textContent); } catch(e){}
  var form = root.querySelector('[data-hh-form]');
  var idInput = root.querySelector('[data-hh-variant-id]');
  var planInput = root.querySelector('[data-hh-plan-input]');
  var addBtn = root.querySelector('[data-hh-add]');
  var priceBox = root.querySelector('[data-hh-price]');
  var stickyPrice = root.querySelector('[data-hh-sticky-price]');
  var stickyBtn = root.querySelector('[data-hh-sticky-add]');
  var stickyQty = root.querySelector('[data-hh-sticky-qty]');
  var q = root.querySelector('[data-hh-qty-input]');
  var plans = root.querySelector('[data-hh-plans]');
  var freqBox = root.querySelector('[data-hh-freq]');
  var renew = root.querySelector('[data-hh-renew]');
  var giftBox = root.querySelector('[data-hh-gift]');
  var giftNote = root.querySelector('[data-hh-gift-note]');
  function money(c){ return '$' + (c/100).toFixed(2); }
  function current(){ return variants.find(function(v){ return String(v.id) === String(idInput.value); }) || variants[0]; }

  /* purchase options */
  function mode(){ var m = plans && plans.querySelector('[data-hh-mode]:checked'); return m ? m.value : 'once'; }
  function planId(){ var f = plans && plans.querySelector('[data-hh-freq-opt]:checked'); return f ? f.value : ''; }
  function alloc(v){ if (!v || !v.selling_plan_allocations) return null; var id = planId(); return v.selling_plan_allocations.find(function(a){ return String(a.selling_plan_id) === String(id); }) || null; }
  function addLabel(){ return mode() === 'sub' ? 'Subscribe' : 'Add to bag'; }
  function syncPlans(){
    if (!plans) { if (planInput) planInput.disabled = true; return; }
    var sub = mode() === 'sub';
    plans.querySelectorAll('.hh-plan').forEach(function(l){ l.classList.toggle('is-on', l.querySelector('input').checked); });
    if (freqBox) freqBox.hidden = !sub;
    planInput.value = sub ? planId() : '';
    planInput.disabled = !sub;
    var v = current(); var a = sub ? alloc(v) : null;
    var now = a ? a.price : v.price;
    if (stickyPrice) stickyPrice.textContent = money(now);
    if (renew && a) {
      var later = a.price_adjustments && a.price_adjustments.length > 1 ? a.price_adjustments[1].price : a.price;
      var f = plans.querySelector('[data-hh-freq-opt]:checked'); var nm = f ? f.getAttribute('data-name') : '';
      var link = renew.querySelector('a'); var linkHtml = link ? ' ' + link.outerHTML : '';
      renew.innerHTML = 'You pay ' + money(a.price) + ' today, then ' + money(later) + ' ' + nm.toLowerCase() + ' until you cancel. Skip or cancel online anytime. We email you 3 days before each charge.' + linkHtml;
    }
    if (addBtn && !addBtn.disabled) addBtn.textContent = addLabel();
    if (stickyBtn) stickyBtn.textContent = sub ? 'Subscribe' : 'Add to cart';
  }
  if (plans) plans.addEventListener('change', syncPlans);
  syncPlans();

  /* gift note */
  if (giftBox && giftNote) {
    giftNote.disabled = true;
    giftBox.addEventListener('change', function(){ giftNote.hidden = !giftBox.checked; giftNote.disabled = !giftBox.checked; if (giftBox.checked) giftNote.focus(); });
  }

  /* variant picker */
  function selected(){ return Array.prototype.map.call(root.querySelectorAll('.hh-opt'), function(fs){ var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
  function findVariant(opts){ return variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); }); }
  function markOut(){
    var opts = selected();
    root.querySelectorAll('[data-hh-opt]').forEach(function(inp){
      var i = Number(inp.getAttribute('data-hh-opt')); var test = opts.slice(); test[i] = inp.value;
      var v = findVariant(test); inp.parentNode.classList.toggle('is-out', !v || !v.available);
    });
  }
  function update(){
    var opts = selected(); var v = findVariant(opts); if (!v) return;
    idInput.value = v.id;
    opts.forEach(function(val,i){ var l = root.querySelector('[data-hh-opt-label="'+i+'"]'); if (l) l.textContent = val; });
    priceBox.innerHTML = '<span class="hh-buy__now">' + money(v.price) + '</span>' + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '');
    addBtn.disabled = !v.available; addBtn.textContent = v.available ? addLabel() : 'Sold out';
    if (stickyBtn) stickyBtn.disabled = !v.available;
    if (v.featured_media) { var el = document.getElementById('hh-media-' + v.featured_media.id); if (el) el.parentNode.scrollTo({ left: el.offsetLeft - el.parentNode.offsetLeft, behavior: 'smooth' }); }
    var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    markOut(); syncPlans();
  }
  root.addEventListener('change', function(e){ if (e.target.matches('[data-hh-opt]')) update(); });
  markOut();

  /* qty, shared by the main box and the sticky bar */
  function setQty(n){ n = Math.min(10, Math.max(1, n || 1)); q.value = n; if (stickyQty) stickyQty.textContent = n; }
  root.addEventListener('click', function(e){
    var s = e.target.closest('[data-hh-step]'); if (!s) return;
    setQty((Number(q.value) || 1) + Number(s.getAttribute('data-hh-step')));
  });
  q.addEventListener('change', function(){ setQty(Number(q.value)); });

  /* add to bag through the drawer */
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  form.addEventListener('submit', function(e){
    e.preventDefault(); addBtn.disabled = true; var label = addBtn.textContent; addBtn.textContent = 'Adding...';
    var item = { id: Number(idInput.value), quantity: Number(q.value) || 1 };
    if (planInput && !planInput.disabled && planInput.value) item.selling_plan = Number(planInput.value);
    if (giftNote && !giftNote.disabled && giftNote.value.trim()) item.properties = { 'Gift note': giftNote.value.trim(), 'Gift': 'Hide prices' };
    fetch(rootUrl + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ items:[item] }) })
      .then(function(r){ if (!r.ok) throw r; return r.json(); })
      .then(function(){ var o = document.querySelector('[data-hh-open-cart]'); if (o) o.click(); else location.href = rootUrl + 'cart'; })
      .catch(function(){ form.submit(); })
      .finally(function(){ addBtn.disabled = false; addBtn.textContent = label; });
  });
  if (stickyBtn) stickyBtn.addEventListener('click', function(){ addBtn.click(); });

  /* sticky bar shows once the main button scrolls away */
  var sticky = root.querySelector('[data-hh-sticky]');
  if (sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function(en){ var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }).observe(addBtn);
  }

  /* gallery: thumbs, dots */
  var track = root.querySelector('[data-hh-track]');
  var thumbs = root.querySelectorAll('[data-hh-thumb]');
  var dots = root.querySelectorAll('.hh-gallery__dots span');
  thumbs.forEach(function(t){ t.addEventListener('click', function(){ var el = document.getElementById('hh-media-' + t.getAttribute('data-hh-thumb')); if (el) track.scrollTo({ left: el.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
  if (track) track.addEventListener('scroll', function(){
    var i = Math.round(track.scrollLeft / track.clientWidth);
    thumbs.forEach(function(t,n){ t.classList.toggle('is-active', n === i); });
    dots.forEach(function(d,n){ d.classList.toggle('is-active', n === i); });
  }, { passive: true });

  /* delivery estimate as real dates */
  var eta = root.querySelector('[data-hh-eta]');
  if (eta) {
    var min = Number(root.getAttribute('data-min-days')) || 4, max = Number(root.getAttribute('data-max-days')) || 7;
    function addBiz(d, n){ d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
    var f = { weekday:'short', month:'short', day:'numeric' }; var now = new Date();
    eta.innerHTML = root.getAttribute('data-ships') + ' <b>' + addBiz(now, min).toLocaleDateString('en-US', f) + ' to ' + addBiz(now, max).toLocaleDateString('en-US', f) + '</b>.';
  }

  /* free shipping line: this item (selected pack, qty, subscribe price) plus what is already in the bag */
  var ship = root.querySelector('[data-hh-ship]');
  var freeAt = Number(root.getAttribute('data-free-at')) || 5000;
  var cartTotal = 0, justAdded = false;
  function unitNow(){ var v = current(); if (!v) return 0; var a = mode() === 'sub' ? alloc(v) : null; return a ? a.price : v.price; }
  function shipLine(){
    if (!ship) return;
    var total = cartTotal + (justAdded ? 0 : unitNow() * (Number(q.value) || 1));
    var left = freeAt - total;
    ship.textContent = left > 0 ? 'Add ' + money(left) + ' more for free US shipping. No duty or fees at your door.' : 'This order ships free to the US. No duty or fees at your door.';
  }
  function loadCart(){ return fetch(rootUrl + 'cart.js', { headers:{ Accept:'application/json' } }).then(function(r){ return r.json(); }).then(function(c){ cartTotal = c.total_price || 0; shipLine(); }).catch(function(){ shipLine(); }); }
  shipLine(); loadCart();
  root.addEventListener('click', function(e){ if (e.target.closest('[data-hh-step]')) { justAdded = false; setTimeout(shipLine, 0); } });
  root.addEventListener('change', function(){ justAdded = false; setTimeout(shipLine, 0); });
  q.addEventListener('input', function(){ justAdded = false; setTimeout(shipLine, 0); });
  document.addEventListener('cart:updated', loadCart);
  form.addEventListener('submit', function(){ setTimeout(function(){ justAdded = true; loadCart(); }, 1500); });

  /* routine builder */
  var routine = document.querySelector('[data-hh-routine]');
  if (routine) {
    var rbtn = routine.querySelector('[data-hh-routine-add]');
    function rsync(){ var n = 0, t = 0; routine.querySelectorAll('input[type=checkbox]').forEach(function(c){ if (c.checked) { n++; t += Number(c.getAttribute('data-price')); } }); rbtn.textContent = 'Add ' + n + (n === 1 ? ' item' : ' items') + ' for ' + money(t); }
    routine.addEventListener('change', rsync); rsync();
    rbtn.addEventListener('click', function(){
      var items = []; routine.querySelectorAll('input[type=checkbox]').forEach(function(c){ if (c.checked) items.push({ id: Number(c.value), quantity: 1 }); });
      rbtn.disabled = true;
      fetch(rootUrl + 'cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){ if (!r.ok) throw r; return r.json(); })
        .then(function(){ var o = document.querySelector('[data-hh-open-cart]'); if (o) o.click(); else location.href = rootUrl + 'cart'; })
        .catch(function(){ location.href = rootUrl + 'cart'; })
        .finally(function(){ rbtn.disabled = false; });
    });
  }

  /* related products */
  var recs = document.querySelector('[data-hh-recs]');
  if (recs && !recs.children.length && recs.dataset.url) {
    fetch(recs.dataset.url).then(function(r){ return r.text(); }).then(function(html){
      var d = document.createElement('div'); d.innerHTML = html; var s = d.querySelector('[data-hh-recs]');
      if (s && s.innerHTML.trim()) recs.innerHTML = s.innerHTML;
    }).catch(function(){});
  }

})();
